import React from 'react'
// import Create from './Create'
// import UserDetail from './UserDetail'
import { useNavigate } from 'react-router-dom';
import PaginatedUserTable from './UsersTable'

const UserDashboard = () => {
  const navigate = useNavigate(); 
  return (
    <div className='bg-[#101523]'>
      <div className='max-w-7xl mx-auto'>
        <div className='flex justify-between items-center px-16 pt-8'>
          <h1 className='text-2xl font-bold text-white'>User Dashboard</h1>
          <button  
            className='bg-[#4b8be9] p-4 rounded-lg hover:bg-blue-600 transition-colors' 
            onClick={()=>{ navigate("/users/create")}}
          >
            Crear Usuario
          </button>
        </div>
        <PaginatedUserTable />
      </div>
    </div>
  )
}

export default UserDashboard
